import AccountType from '@/entities/AccountType.js';
import Enum from './Enum.js';
import i18n from '../plugins/vue-i18n.js';

export default class ClientCardSection extends Enum {
    static get entries() {
        return {
            dealNavigatorSale: 'dealNavigator.sale',
            dealNavigatorDelivery: 'dealNavigator.delivery',
            dealNavigatorCredit: 'dealNavigator.credit',
            generalInfo: 'generalInfo',
            dealNavigatorPresentation: 'dealNavigator.presentation',
            wantedVehicleDetails: 'wantedVehicleDetails',
            wantedVehicleDealInformation: 'wantedVehicleDealInformation',
            exchangeVehicleDetails: 'exchangeVehicleDetails',
            exchangeVehicleAppraisal: 'exchangeVehicleAppraisal',
            processService: 'processService',
            funnel: 'funnel',
            dollarAndLost: 'dollarAndLost',
        };
    }

    static get DEAL_NAVIGATOR_SALE() {
        return this.entries.dealNavigatorSale;
    }

    static get DEAL_NAVIGATOR_CREDIT() {
        return this.entries.dealNavigatorCredit;
    }

    static get DEAL_NAVIGATOR_DELIVERY() {
        return this.entries.dealNavigatorDelivery;
    }

    static get GENERAL_INFO() {
        return this.entries.generalInfo;
    }

    static get DEAL_NAVIGATOR_PRESENTATION() {
        return this.entries.dealNavigatorPresentation;
    }

    static get WANTED_VEHICLE_DETAILS() {
        return this.entries.wantedVehicleDetails;
    }

    static get WANTED_VEHICLE_DEAL_INFORMATION() {
        return this.entries.wantedVehicleDealInformation;
    }

    static get EXCHANGE_VEHICLE_DETAILS() {
        return this.entries.exchangeVehicleDetails;
    }

    static get EXCHANGE_VEHICLE_APPRAISAL() {
        return this.entries.exchangeVehicleAppraisal;
    }

    static get PROCESS_SERVICE() {
        return this.entries.processService;
    }

    static get FUNNEL() {
        return this.entries.funnel;
    }

    static get DOLLAR_AND_LOST() {
        return this.entries.dollarAndLost;
    }

    static get translationGroup() {
        return 'clientCard.customFieldSections';
    }

    static get leadGroup() {
        return 'lead';
    }

    static get vehicleExchangeGroup() {
        return 'vehicleExchange';
    }

    static get vehicleWantedGroup() {
        return 'vehicleWanted';
    }

    static get leadSections() {
        return [
            this.GENERAL_INFO,
            this.DEAL_NAVIGATOR_PRESENTATION,
            this.DEAL_NAVIGATOR_SALE,
            this.DEAL_NAVIGATOR_CREDIT,
            this.DEAL_NAVIGATOR_DELIVERY,
            this.PROCESS_SERVICE,
            this.FUNNEL,
            this.DOLLAR_AND_LOST,
        ];
    }

    static get vehicleExchangeSections() {
        return [this.EXCHANGE_VEHICLE_DETAILS, this.EXCHANGE_VEHICLE_APPRAISAL];
    }

    static get vehicleWantedSections() {
        return [this.WANTED_VEHICLE_DETAILS, this.WANTED_VEHICLE_DEAL_INFORMATION];
    }

    static getSectionGroup(section) {
        if (this.isVehicleExchangeField(section)) {
            return this.vehicleExchangeGroup;
        }

        if (this.isVehicleWantedField(section)) {
            return this.vehicleWantedGroup;
        }

        return this.leadGroup;
    }

    static isLeadField(section) {
        return this.leadSections.includes(section);
    }

    static isVehicleField(section) {
        return this.isVehicleExchangeField(section) || this.isVehicleWantedField(section);
    }

    static isVehicleExchangeField(section) {
        return this.vehicleExchangeSections.includes(section);
    }

    static isVehicleWantedField(section) {
        return this.vehicleWantedSections.includes(section);
    }

    static selectOptionsWithGroups(account, idName = '', labelName = '') {
        const accountIsCustom = account.type === AccountType.CUSTOM;

        return [
            {
                label: i18n.t('clientCard.customFieldSections.group.lead'),
                group: this.leadGroup,
                options: this.leadSections
                    .filter(
                        (section) =>
                            accountIsCustom ||
                            ![this.FUNNEL, this.DOLLAR_AND_LOST].includes(section)
                    )
                    .map((section) => this.getSelectOption(section, idName, labelName)),
            },
            {
                label: i18n.t('clientCard.customFieldSections.group.vehicleExchange'),
                group: this.vehicleExchangeGroup,
                options: this.vehicleExchangeSections.map((section) =>
                    this.getSelectOption(section, idName, labelName)
                ),
            },
            {
                label: i18n.t('clientCard.customFieldSections.group.vehicleWanted'),
                group: this.vehicleWantedGroup,
                options: this.vehicleWantedSections.map((section) =>
                    this.getSelectOption(section, idName, labelName)
                ),
            },
        ];
    }
}
